import { motion } from "framer-motion";
import { ArrowRight, Bot, PlugZap, Workflow, Brain, Phone, Sparkles } from "lucide-react";
import { NavLink } from "react-router-dom";
import { GridGlow } from "../commons/GridGlow";
import { Pill, ValueCard } from "../commons/UI";
import { ServiceGrid } from "./ServiceGrid";
import { ClientsSection } from "./ClientsSection";

export const Home = () => (
  <>
    <section className="relative overflow-hidden rounded-3xl mt-10 bg-gradient-to-br from-indigo-700/30 via-indigo-500/10 to-fuchsia-600/10 border border-white/10">
      <GridGlow />
      <div className="relative px-6 py-16 md:px-12 md:py-24">
        <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-slate-200">
          <Sparkles className="w-4 h-4 text-indigo-300" />
          AI‑first studio
        </div>
        <motion.h1 initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-4xl md:text-6xl font-black tracking-tight text-slate-100">
          Agentes y software inteligente <span className="text-indigo-300">para crecer</span>
        </motion.h1>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }} className="mt-5 max-w-2xl text-slate-300 text-lg">
          Implementamos AI Agents, MCPs, ChatBots y automatizaciones n8n integradas a tu stack. De la idea al producto en semanas, con foco en impacto.
        </motion.p>
        <div className="mt-6 flex flex-wrap gap-2 text-xs">
          <Pill>AI Agents</Pill>
          <Pill>MCP Servers</Pill>
          <Pill>ChatBots</Pill>
          <Pill>n8n</Pill>
          <Pill>RAG</Pill>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row gap-3">
          <NavLink to="/contacto" className="inline-flex items-center justify-center rounded-2xl px-5 py-3 bg-indigo-500/80 hover:bg-indigo-500 text-white font-semibold shadow">
            Contanos tu proyecto <ArrowRight className="w-4 h-4 ml-2" />
          </NavLink>
          <NavLink to="/servicios" className="inline-flex items-center justify-center rounded-2xl px-5 py-3 border border-white/15 hover:bg-white/5">
            Ver servicios
          </NavLink>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-4">
          <ValueCard title="AI Agents en producción" icon={<Bot className="w-6 h-6" />}
            text="Agentes con memoria, herramientas y trazabilidad para operaciones reales." />
          <ValueCard title="MCP seguro y escalable" icon={<PlugZap className="w-6 h-6" />}
            text="Conectores versionados, permisos y monitoreo para tools confiables." />
          <ValueCard title="Automatización n8n" icon={<Workflow className="w-6 h-6" />}
            text="Workflows inteligentes con aprobaciones humanas y métricas claras." />
        </div>
      </div>
    </section>

    <section className="mt-16">
      <h2 className="text-2xl md:text-3xl font-bold text-slate-100">¿Qué hacemos?</h2>
      <p className="text-slate-400 mt-2">Soluciones AI‑first end‑to‑end con foco en negocio, performance y UX.</p>
      <ServiceGrid minimal />
    </section>

    <ClientsSection className="mt-14" />

    <section className="mt-16 grid md:grid-cols-3 gap-6">
      <ValueCard title="RAG con tus datos" icon={<Brain className="w-6 h-6" />}
        text="Búsqueda semántica, embeddings y fuentes trazables para respuestas confiables." />
      <ValueCard title="Automatización con control" icon={<Workflow className="w-6 h-6" />}
        text="Procesos críticos con approvals, métricas y alertas en tiempo real." />
      <ValueCard title="Partnership real" icon={<Phone className="w-6 h-6" />}
        text="Comunicación clara, roadmap compartido y foco en ROI desde el día uno." />
    </section>
  </>
);
